import { render, staticRenderFns } from "./TopNews.vue?vue&type=template&id=76eca3cc&scoped=true&"
import script from "./TopNews.vue?vue&type=script&lang=js&"
export * from "./TopNews.vue?vue&type=script&lang=js&"
import style0 from "./TopNews.vue?vue&type=style&index=0&id=76eca3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eca3cc",
  null
  
)

export default component.exports